import { Link } from 'react-router-dom';
import SectionHeader from '@/components/feature/SectionHeader';
import { movies } from '@/mocks/movies';
import { getHotMovies } from '@/utils/content';

export default function HotRanking() {
  const list = getHotMovies(movies, 8);

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-portal px-4 py-10 md:px-6 md:py-14">
        <SectionHeader
          eyebrow="热度排行"
          title="热门影视榜单"
          description="根据站内浏览量综合排名的热度榜单，看看大家都在追什么。"
          moreLink="/category/电影"
          moreText="查看全部"
        />
        <div className="grid grid-cols-1 gap-x-8 gap-y-1 md:grid-cols-2">
          {list.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-4 rounded-lg px-2 py-3 transition-colors hover:bg-background-50"
            >
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black ${
                  index < 3 ? 'bg-accent-500 text-background-950' : 'bg-background-200 text-foreground-600'
                }`}
              >
                {index + 1}
              </span>
              <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} ${movie.type}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {movie.title}
                </h3>
                <p className="mt-1 truncate text-xs text-foreground-500">
                  {movie.type} · {movie.year} · {movie.genres.slice(0, 2).join(' / ')}
                </p>
                <div className="mt-1.5 flex items-center gap-3 text-xs">
                  <span className="flex items-center gap-1 font-semibold text-accent-600">
                    <i className="ri-star-fill" />
                    {movie.rating.toFixed(1)}
                  </span>
                  <span className="flex items-center gap-1 text-foreground-400">
                    <i className="ri-fire-line" />
                    {movie.heat.toLocaleString('zh-CN')}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line hidden text-xl text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-primary-500 sm:block" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}